import Popup from "./Popup"

const Informazioni = () => {
    const chiudi_info=()=>{
        document.querySelector("#informazioni").classList.add("chiuso")
    }
    return (
        <Popup id="informazioni" title="Informazioni sulla prenotazione" onClose={chiudi_info}>
            <h3>Fasce:</h3>
            <p>Il sistema di prenotazione si basa sulle fasce, fino alle 17 la fascia è bianca, da quell'ora diventa nera. Nel campo di touchtennis c'è solo fascia bianca. Sabato e domenica la fascia è sempre bianca.</p>
            <h3>Under 13:</h3>
            <p>Possono prenotare solo touchtennis o un campo qualsiasi giocando con un maggiorenne.</p>
            <h3>Non soci:</h3>
            <p>Possono prenotare solo 2 giorni prima. E' possibile prenotare 2 ore, di cui 1 in fascia nera e una bianca, o entrambe bianche.</p>
            <h3>Soci:</h3>
            <p>Possono prenotare per la settimana in corso e quella successiva. E' possibile prenotare 2 ore, di cui 1 in fascia nera e una bianca, o entrambe bianche.</p>
            <h3>Maestri:</h3>
            {/* <p>Possono prenotare per la settimana in corso e quelle due successive, M1 può prenotare qualsiasi ora, mentre M2 può prenotare solo ore in fascia bianca.</p> */}
            <p>Possono prenotare per la settimana in corso e quelle due successive, il maestro può prenotare qualsiasi ora.</p> 
            <hr/>
            <h3>Prezzi:</h3>
            <b style={{fontSize:"0.9rem"}}>Lezioni da 55' Adulti (primo prezzo SOCI, secondo prezzo NON SOCI)</b>
            <ul>
                <li>Lezione individuale: 25€/33€</li>
                <li>Lezione in due: 16€/20€ (a testa)</li>
                <li>Lezione in tre: 12€/15€ (a testa)</li>
            </ul>
            <b style={{fontSize:"0.9rem"}}>Lezioni da 55' Under 18 (primo prezzo SOCI, secondo prezzo NON SOCI)</b>
            <ul>
                <li>Lezione individuale: 22€/28€</li>
                <li>Lezione in due: 12€/16€ (a testa)</li>
                <li>Lezione in tre: 9€/12€ (a testa)</li>
                <li>Lezione in quattro: 8€/10€ (a testa)</li>
            </ul>
            {/* <b style={{fontSize:"0.9rem"}}>Lezioni da 45' (MINI TENNIS 4-9 anni)</b>
            <ul>
                <li>Lezione individuale: 15€</li>
                <li>Lezione in due: 8€  (a testa)</li>
                <li>Lezione in tre: 6€  (a testa)</li>
                <li>Lezione in quattro: 5€  (a testa)</li>
                <li>Lezione in cinque: 4€  (a testa)</li>
            </ul> */}
            {/* <b style={{fontSize:"0.9rem"}}>Quote tesseramenti (dal 28/03 al 30/10 2022):</b>
            <ul>
                <li>UOMO: 190€</li>
                <li>DONNA: 160€</li>
                <li>UNDER 25 (uomo): 120€</li>
                <li>UNDER 25 (donna): 100€</li>
                <li>UNDER 20: 75€</li>
                <li>UNDER 15: 30€</li>
            </ul> */}
        </Popup>
    )
}

export default Informazioni